/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function l(l){const{attributes:t,sourceLayer:n}=l??{},i=n&&"displayField"in n?n.displayField:null,e=i?t?.[i]:null,r=null!=e?JSON.stringify(e):null,u=l?.getObjectId()?.toString();return r||u||""}export{l as getFeatureTitle};
